import {UserRole} from "../../core/models/fixture/userRole";
import {UserInfo} from "../../core/models/utilTypes";

const initialState: UserInfo = {
  id: '',
  name: '',
  email: '',
  myTeamId: '',
  myTeam: '',
  myTeamRegion: 0,
  role: UserRole.guest
}

const reducer = (state: UserInfo, action: any) => {
  switch (action.type) {
    case "login":
      return action.payload.user
    case "logout":
      return initialState
    case "update":
      return action.payload.user
    default:
      return state
  }
}

export default {
  initialState,
  reducer,
}
